module.exports = __webpack_public_path__ + "img/xx.ee334926.svg";